import { TextInputField as CascadiaTextInputField } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { Field } from "formik";

export function TextInputField({
  field: config,
}: {
  field: components["schemas"]["TextCheckField"];
}) {
  return (
    <Field
      as={CascadiaTextInputField}
      label={config.label}
      name={config.name}
      placeholder={config.placeholder}
      isRequired={config.required}
    />
  );
}
